import React, { useState } from "react";
import { UserManagement } from "./UserManagement";
import { ColorManagement } from "./ColorManagement";
import { AppSettings } from "./AppSettings";

export function Settings() {
  const [activeTab, setActiveTab] = useState("general");

  const tabClass = (tab) =>
    `py-4 px-2 border-b-2 font-medium text-sm ${
      activeTab === tab
        ? "border-blue-500 text-blue-600"
        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
    }`;

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Configuración</h1>

      <div className="bg-white rounded-lg shadow">
        <div className="border-b">
          <div className="flex space-x-4 px-4">
            <button onClick={() => setActiveTab("general")} className={tabClass("general")}>
              General
            </button>
            <button onClick={() => setActiveTab("users")} className={tabClass("users")}>
              Usuarios
            </button>
            <button onClick={() => setActiveTab("colors")} className={tabClass("colors")}>
              Colores
            </button>
          </div>
        </div>

        <div className="p-6">
          {activeTab === "general" && (
            <div>
              <h2 className="text-xl font-semibold mb-4">Configuración General</h2>
              <AppSettings />
            </div>
          )}
          {activeTab === "users" && (
            <div>
              <h2 className="text-xl font-semibold mb-4">Gestión de Usuarios</h2>
              <UserManagement />
            </div>
          )}
          {activeTab === "colors" && (
            <div>
              <h2 className="text-xl font-semibold mb-4">Gestión de Colores</h2>
              <ColorManagement />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
